import type { ExtractValues } from '../helpers';
import { Joi, objectSchemaOf } from '../helpers';

export const entityOverrideMode = ['supplement', 'override'] as const;
export type EntityOverrideMode = ExtractValues<typeof entityOverrideMode>;
export const entityOverrideModeSchema = Joi.string().valid(
  ...entityOverrideMode
);

export interface IEntity {
  value: string;
  synonyms: string[];
}

export const entitySchema = objectSchemaOf<IEntity>({
  value: Joi.string().required(),
  synonyms: Joi.array().items(Joi.string()).required(),
});

export interface IEntityType {
  name: string;
  mode: EntityOverrideMode;
  entities: IEntity[];
}

export const entityTypeSchema = objectSchemaOf<IEntityType>({
  name: Joi.string().required(),
  mode: entityOverrideModeSchema.required(),
  entities: Joi.array().items(entitySchema).required(),
});
